/**
 * Shared goal vocabulary. Onboarding captures it as a two-tap quest; the
 * profile page lets the learner change it later. One source of truth so the
 * labels never drift between the two surfaces.
 */
export const GOALS = [
  {
    id: "pick_stream",
    label: "Pick the right stream or subjects",
    hint: "You're deciding what to study next.",
    emoji: "🧭",
  },
  {
    id: "find_career",
    label: "Find careers that fit me",
    hint: "You want options that actually suit you.",
    emoji: "✨",
  },
  {
    id: "get_hired",
    label: "Get hired or find an internship",
    hint: "You're ready to step into work.",
    emoji: "🚀",
  },
  {
    id: "switch_path",
    label: "Change direction",
    hint: "Something isn't working — you want a new path.",
    emoji: "🔄",
  },
  {
    id: "just_explore",
    label: "Just explore for now",
    hint: "No pressure. You're curious.",
    emoji: "🌱",
  },
] as const;

export const TIMEFRAMES = [
  { id: "now", label: "Right now", emoji: "⚡" },
  { id: "3_months", label: "Next 3 months", emoji: "📅" },
  { id: "this_year", label: "This year", emoji: "🗓️" },
  { id: "someday", label: "No deadline", emoji: "🌤️" },
] as const;

export type GoalId = (typeof GOALS)[number]["id"];
export type TimeframeId = (typeof TIMEFRAMES)[number]["id"];

export const goalLabel = (id: string | null | undefined) =>
  GOALS.find((g) => g.id === id)?.label ?? null;

export const timeframeLabel = (id: string | null | undefined) =>
  TIMEFRAMES.find((t) => t.id === id)?.label ?? null;
